/*
 * @Author: zhaoyian zhaopeng1957462481@163.com
 * @Date: 2023-11-09 20:04:03
 * @LastEditors: zhaoyian zhaopeng1957462481@163.com
 * @LastEditTime: 2023-11-14 09:44:19
 * @FilePath: \yunque\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

createApp(App).use(router).use(ElementPlus).mount('#app')
